export default "__VITE_ASSET__BUYUPpcv__"